<template>
    <div>
        <v-overlay @click.native="$emit('onOverlayClicked')" :value="drawerStatus == 'expanded'" :z-index="zIndex - 1"></v-overlay>
        <div sticky-container class="drawer" :class="drawerStatus" :style="cssVars">
            <v-row v-if="hasHeader" no-gutters class="py-4 header-bg-color">
                <v-col cols="10">
                    <span class="px-5 text-h3 font-weight-bold">{{ title }}&nbsp;<span class="text-h4">{{ subtitle }}</span></span>
                </v-col>
                <v-col cols="2" class="text-right">
                    <v-icon @click="$emit('onDismiss')" class="mr-4" size="36" :color="headerIconColor">mdi-close</v-icon>
                </v-col>
            </v-row>
            <v-row class="mt-3" no-gutters v-else>
                <v-col class="text-right">
                    <v-icon @click="$emit('onDismiss')" class="mr-4" size="36" :color="headerIconColor">mdi-close</v-icon>
                </v-col>
            </v-row>            
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {

        components: {
        },

        name: 'drawer',

        props: {
            drawerStatus: { type: String },
            bgColor: { type: String },
            drawerWidth: { type: String },
            zIndex: { type: [Number, String] },
            title: { type: String },
            subtitle: { type: String },
            headerBgColor: { type: String },
            headerIconColor: { type: String },
            hasHeader: {
                type: Boolean,
                default: true,
                required: false,
            },            
        },  
        
        mounted: () => { },

        computed: {
            cssVars () {
                return  {
                    /* variables you want to pass to css */
                    '--bgColor': this.bgColor ? this.bgColor : 'white',
                    '--drawerWidth': this.drawerWidth,
                    '--minusDrawerWidth': '-' + this.drawerWidth,
                    '--zIndex': this.zIndex,
                    '--headerBgColor': this.headerBgColor ? this.headerBgColor : 'white',
                }            
            },
        },

        watch: { },

        methods: { },

        data: () =>  ({
            blockchainRequests: [],
        })

    }
</script>

<style scoped lang="scss">

    .drawer {
        position: fixed;
        top: 0;
        background-color:var(--bgColor);
        height: 100%;
        width: var(--drawerWidth);
        z-index: var(--zIndex);
        -webkit-transition: all 1s ease;
        -moz-transition: all 1s ease;
        -o-transition: all 1s ease;
        transition: all 1s ease;
        overflow: scroll;                
    }

    .drawer.expanded {
        right: 0;
    }

    .collapsed {
        right: var(--minusDrawerWidth);
    }

    .header-bg-color {
        background-color: var(--headerBgColor);
    }

</style>
